import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Rating,
  Button,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Typography,
  Checkbox,
  ListItemText,
  Autocomplete,
  CircularProgress,
  Popper,
  Stack,
  Box,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { useSelector } from "react-redux";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../Utility/Utilitys";
import { CmpDatePicker } from "../../Component/Common/ToolBox/ToolBox";
import theme from "../../Theme";
import {
  onGetHRMonthly_EvaluationDetail_GetRow_CONFIRM,
  onGetHRMonthly_EvaluationHead_Confirm_Summary,
  onGetHRMonthly_EvaluationHead_POST_CONFIRM,
  onGetHRMonthly_EvaluationRating_List_GetRow_CONFIRM,
  onGetHRMonthly_Evaluation_Update_CONFIRM,
} from "./HRMonthlyReviewAction";

const statusOptions = ["ENTER", "POST", "DELETE"];

const screen1Columns = [
  { field: "A_TransID", headerName: "Trans ID", width: 90 },
  {
    field: "A_TransDate",
    headerName: "Trans Date",
    width: 100,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  { field: "A_Loc", headerName: "Location", width: 180, hide: true },
  { field: "LocName", headerName: "Location", width: 200 },
  { field: "A_ConfirmStatus", headerName: "Confirm Status", width: 120 },
  { field: "A_Narration", headerName: "Narration", width: 150 },
];

const screen2Columns = [
  { field: "EMPID", headerName: "EMP. ID", width: 95 },
  { field: "EMPName", headerName: "EMP. Name", width: 300 },
  { field: "Department", headerName: "Department", width: 150 },
  { field: "JobTitleName", headerName: "Job Title", width: 150 },
  { field: "CurrentLocation", headerName: "Current Branch", width: 150 },
  { field: "MainLocation", headerName: "Main Branch", width: 150 },
  { field: "SupervisorName", headerName: "Supervisor", width: 150 },
  { field: "B_Rating", headerName: "Rating", width: 80 },
  { field: "B_Perc", headerName: "Perc", width: 80 },
];

export default function HRMonthlyReview() {
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxDBLocation = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const [openScreen2, setOpenScreen2] = useState(false);
  const [openRatingDialog, setOpenRatingDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [rows1, setRows1] = useState([]);
  const [rows2, setRows2] = useState([]);
  const [ratingRows, setRatingRows] = useState([]);
  const [summary, setSummary] = useState({
    fromDate: moment().format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
    location: [vRdxDBLocation[0]?.Uid],
    status: ["ENTER"],
  });

  const [jobDetailSummary, setJobDetailSummary] = useState({
    transId: "0",
    date: moment().format("YYYY-MM-DD"),
    location: "",
    narration: "",
    status: "",
  });

  const handleRatingChange = (id, field, newValue) => {
    setRatingRows((prev) =>
      prev.map((row) => (row.SrNo === id ? { ...row, [field]: newValue } : row))
    );
  };

  const calculatePercentage = () => {
    if (ratingRows.length === 0) return 0;
    const totalStars = ratingRows.reduce(
      (sum, row) => sum + (row.Rating || 0),
      0
    );
    return (
      Math.round((totalStars / (ratingRows.length * 10)) * 100 * 100) / 100
    );
  };

  const ratingColumns = [
    { field: "Description", headerName: "Description", width: 500 },
    {
      field: "Rating",
      headerName: "Rating",
      width: 250,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={0.5}>
          <Rating
            name={`rating-${params.row.SrNo}`}
            value={params.row.Rating || 0}
            max={10}
            onChange={(event, newValue) =>
              handleRatingChange(params.row.SrNo, "Rating", newValue)
            }
          />
          <Typography variant="body2" color="primary">
            {params.row.Rating || 0}/10
          </Typography>
        </Box>
      ),
    },
    {
      field: "Narration",
      headerName: "Narration",
      width: 200,
      renderCell: (params) => (
        <TextField
          fullWidth
          variant="outlined"
          value={params.row.Narration || ""}
          onChange={(e) =>
            handleRatingChange(params.row.SrNo, "Narration", e.target.value)
          }
        />
      ),
    },
  ];

  const handleJobDetailLocationChange = (event) => {
    setJobDetailSummary((prev) => ({ ...prev, location: event.target.value }));
  };
  const handleLocationChange = (newValue) => {
    const selectedUids = newValue.map((loc) => loc.Uid);
    setSummary((prev) => ({ ...prev, location: selectedUids }));
  };

  const handleLoad = async () => {
    // Simulate API call

    const obj = {
      P_StartDate: moment(summary?.fromDate).format("MM-DD-YYYY"),
      P_EndDate: moment(summary?.toDate).format("MM-DD-YYYY"),
      P_Location: (summary?.location).toString(),
      P_A_ConfirmStatus: (summary?.status).toString(),
      P_UserCd: vRdxuserInfo?.UserID || "",
    };

    const response = await onGetHRMonthly_EvaluationHead_Confirm_Summary(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      console.log("handleDetails", response?.data?.ResultSet);
      setRows1(response?.data?.ResultSet);
    } else {
      setRows1([]);
    }
  };

  const handleAddNew = async (
    transId = jobDetailSummary.transId,
    loc = jobDetailSummary?.location
  ) => {
    setOpenScreen2(true);
    const obj = {
      TransId: transId,
      Loc: loc,
    };

    const response = await onGetHRMonthly_EvaluationDetail_GetRow_CONFIRM(
      fcheck_null_undefine_replace_empty(obj)
    );
    console.log(response.data);

    if (response?.status === 200 && response?.data?.ResultSet) {
      console.log("handleDetails", response);
      // const formattedRows = response?.ResultSet.map((row) => ({
      //   ...row,
      //   id: row.EMPID, // Assign A_TransID as id
      // }));
      setRows2(response?.data?.ResultSet);
    } else {
      setRows2([]);
    }
  };
  const handleRatingList = async (EmpID) => {
    const obj = {
      TransID: jobDetailSummary?.transId,
      EMPID: EmpID,
    };

    const response = await onGetHRMonthly_EvaluationRating_List_GetRow_CONFIRM(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      // const formattedRows = response?.ResultSet.map((row) => ({
      //   ...row,
      //   id: row.SrNo, // Assign A_TransID as id
      // }));
      setRatingRows(response?.data?.ResultSet);
    } else {
      setRatingRows([]);
    }
  };
  const handleSave = async () => {
    const formattedRatingRows = ratingRows.map((row) => ({
      P_C_SrNo: row?.SrNo || "",
      P_C_Description: row?.Description || "",
      P_C_Rating: row?.Rating || 0,
      P_C_Narration: row?.Narration || "",
    }));
    const obj = {
      TransID: jobDetailSummary?.transId,
      // TransDate: moment(jobDetailSummary?.date).format("MM/DD/YYYY"),
      // Loc: jobDetailSummary?.location,
      Narration: jobDetailSummary?.narration,
      // Status: jobDetailSummary?.status,
      // UserCd: vRdxuserInfo?.UserID || "",
      EmpID: selectedEmployee?.EMPID,
      RatingDetails: formattedRatingRows,
    };

    const response = await onGetHRMonthly_Evaluation_Update_CONFIRM(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.ResultSet) {
      handleAddNew(jobDetailSummary.transId);
      setOpenRatingDialog(false);
      setRatingRows([]);
      fAlertToast("SUCCESS", "Saved Successfully");
    }
  };
  const handleConfirmHeadPost = async () => {
    const missingRating = rows2.some((employee) => employee.B_Rating === "");
    if (missingRating) {
      fAlertToast(
        "WARNING",
        "Some Employee review is missing, Check the Grid -> Rating Field"
      );
      return; // Prevent posting if any employee rating is missing.
    }
    const obj = {
      P_A_TransID: jobDetailSummary?.transId,
      P_UserCd: vRdxuserInfo?.UserID || "",
    };

    const response = await onGetHRMonthly_EvaluationHead_POST_CONFIRM(
      fcheck_null_undefine_replace_empty(obj)
    );
    if (response?.status === 200 && response?.data?.Type === "Success") {
      fAlertToast("SUCCESS", "Successfully Posted");
      setOpenScreen2(false);
      handleLoad();
    }
  };
  useEffect(() => {
    handleLoad();
  }, []);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <>
    <div className="div-container">
      <Grid container spacing={1} mt={1} mb={2}>
        <Grid item xs={6} sm={2.5} md={1.5}>
          <div style={{ width: "100%" }}>
            <CmpDatePicker
              xLabelText={"From Date"}
              xValue={summary.fromDate}
              xOnChange={(newValue) =>
                setSummary((prev) => ({ ...prev, fromDate: newValue.$d }))
              }
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
              xFullWidth={true}
              size="small"
              isFoucesd={true}
            />
          </div>
        </Grid>
        <Grid item xs={6} sm={2.5} md={1.5}>
          <div style={{ width: "100%" }}>
            <CmpDatePicker
              xLabelText={"To Date"}
              xValue={summary.toDate}
              xOnChange={(newValue) =>
                setSummary((prev) => ({ ...prev, toDate: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
              xFullWidth={true}
              size="small"
            />
          </div>
        </Grid>
        <Grid item xs={6} sm={7} md={3.8}>
          <Autocomplete
            multiple
            size="small"
            options={vRdxDBLocation || []}
            getOptionLabel={(option) => option?.Name1 || ""}
            value={
              vRdxDBLocation?.filter((loc) =>
                Array.isArray(summary.location)
                  ? summary.location.includes(loc.Uid)
                  : []
              ) || []
            }
            isOptionEqualToValue={(option, value) => option.Uid === value.Uid}
            onChange={(event, newValue) => handleLocationChange(newValue)}
            disableCloseOnSelect
            PopperComponent={(props) => (
              <Popper
                {...props}
                style={{
                  zIndex: 1300,
                }}
                placement="bottom-start"
              />
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location"
                placeholder="Search..."
                size="small"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  fontSize: "12px",
                  "& .MuiOutlinedInput-root": {
                    maxHeight: "32px",
                    overflowY: "auto",
                    border: "1px solid #ddd",
                  },
                }}
              />
            )}
            renderOption={(props, option, { selected }) => (
              <MenuItem
                {...props}
                sx={{
                  height: "31px", // Set the exact height
                  minHeight: "31px", // Ensure the height is consistent
                  padding: "0 8px", // Adjust padding to match the height
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  size="small"
                  icon={icon}
                  checkedIcon={checkedIcon}
                  checked={selected}
                />
                <ListItemText
                  primary={option?.Name1}
                  primaryTypographyProps={{
                    fontSize: "12px",
                    lineHeight: "1.2",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                />
              </MenuItem>
            )}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={2.4}>
          <FormControl fullWidth size="small" sx={{ minHeight: "30px" }}>
            <InputLabel sx={{ fontSize: "12px" }}>Status</InputLabel>
            <Select
              multiple
              value={summary.status || []}
              label="Status"
              onChange={(e) =>
                setSummary((prev) => ({ ...prev, status: e.target.value }))
              }
              renderValue={(selected) => {
                if (!selected.length) return "Select Status";
                return selected.join(", ");
              }}
              sx={{ height: "30px", minHeight: "30px" }}
            >
              {statusOptions.map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{
                    height: "31px", // Set the exact height
                    minHeight: "31px", // Ensure the height is consistent
                    padding: "0 8px", // Adjust padding to match the height
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    checked={summary.status?.includes(option)}
                    size="small"
                  />
                  <ListItemText primary={option} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={6} sm={6} md={2.4}>
          <Stack direction={"row"}>
            <Button
              size="small"
              variant="contained"
              sx={{ mr: 1 }}
              onClick={handleLoad}
            >
              Load
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: {
            xs: "62.5vh",
            sm: "61.5vh",
            md: "75vh",
            lg: "76vh",
            xl: "79vh",
          },
          width: "100%",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          rows={rows1}
          columns={screen1Columns}
          getRowId={(row) => row.A_TransID}
          components={{
            Toolbar: GridToolbar,
          }}
          hideFooter={rows1.length < 100}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
              '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
          }}
          onRowClick={(params) => {
            console.log(params.row);
            setJobDetailSummary((prev) => ({
              ...prev,
              location: params?.row?.A_Loc,
              transId: params?.row?.A_TransID,
              date: params?.row?.A_TransDate,
              narration: params?.row?.A_Narration,
              status: params?.row?.A_ConfirmStatus,
            }));
            setOpenScreen2(true);
            handleAddNew(params.row.A_TransID, params?.row?.A_Loc);
          }}
        />
      </Box>
      {/* Screen 2 Dialog */}
      <Dialog
        disableEnforceFocus
        open={openScreen2}
        onClose={() => {
          setOpenScreen2(false);
          handleLoad();
        }}
        maxWidth={"xl"}
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: "white",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontWeight: "bold" }}> Job Details</span>
          <IconButton
            onClick={() => {
              setOpenScreen2(false);
              handleLoad();
            }}
            style={{ float: "right", color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            // paddingTop: "24px !important",
            padding: { xs: "8px !important", sm: "20px 16px !important" },
          }}
        >
          <Grid container spacing={1} alignItems={"center"}>
            <Grid item xs={6} sm={2.4}>
              <TextField
                label="Trans ID"
                fullWidth
                size="small"
                disabled
                InputLabelProps={{ shrink: true }}
                value={jobDetailSummary?.transId}
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <FormControl
                fullWidth
                size="small"
                sx={{ minHeight: "30px" }}
                disabled={jobDetailSummary?.transId !== "0"}
              >
                <InputLabel
                  id="location-label"
                  sx={{ fontSize: "12px", top: "-5px" }}
                  shrink
                >
                  Location
                </InputLabel>
                <Select
                  labelId="location-label"
                  value={jobDetailSummary?.location || ""}
                  onChange={handleJobDetailLocationChange}
                  displayEmpty
                  label="Location"
                  sx={{
                    height: "30px",
                    minHeight: "30px",
                    "& .MuiSelect-select": {
                      padding: "4px !important",
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Location
                  </MenuItem>
                  {vRdxDBLocation?.length > 0 &&
                    vRdxDBLocation?.map((loc) => (
                      <MenuItem key={loc.Uid} value={loc.Uid}>
                        {loc.Name1}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <CmpDatePicker
                xFullWidth={true}
                xLabelText={"Date"}
                xDisable={jobDetailSummary?.transId !== "0"}
                xValue={jobDetailSummary?.date}
                xOnChange={(newValue) =>
                  setJobDetailSummary((prev) => ({
                    ...prev,
                    date: newValue.$d,
                  }))
                }
                xName={"Date"}
                xError={false}
                xErrorMessage={false}
                size="small"
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <TextField
                label="Narration"
                fullWidth
                size="small"
                value={jobDetailSummary.narration}
                onChange={(e) =>
                  setJobDetailSummary((prev) => ({
                    ...prev,
                    narration: e.target.value,
                  }))
                }
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} sm={2.4}>
              <Stack direction={"row"}>
                {jobDetailSummary?.status === "ENTER" && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    sx={{ mr: 1 }}
                    onClick={handleConfirmHeadPost}
                    disabled={jobDetailSummary.transId == "0"}
                  >
                    Post
                  </Button>
                )}
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    handleAddNew(
                      jobDetailSummary?.transId,
                      jobDetailSummary?.location
                    )
                  }
                >
                  Load
                </Button>
              </Stack>
            </Grid>
          </Grid>
          <Box sx={{ height: "72vh", width: "100%", marginTop: 1 }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={rows2}
              columns={screen2Columns}
              getRowId={(row) => row.EMPID}
              components={{
                Toolbar: GridToolbar,
              }}
              hideFooter={rows2.length < 100}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
              }}
              onRowClick={(params) => {
                setSelectedEmployee(params.row);
                setOpenRatingDialog(true);
                handleRatingList(params.row.EMPID);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
      {/* Rating Dialog */}
      <Dialog
        open={openRatingDialog}
        onClose={() => {
          setOpenRatingDialog(false);
          handleAddNew();
          setRatingRows([]);
        }}
        maxWidth={"lg"}
        fullWidth
      >
        <DialogTitle
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: "white",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Performance Rating</span>
          <IconButton
            onClick={() => {
              setOpenRatingDialog(false);
              handleAddNew();
            }}
            style={{ float: "right", color: "white" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            paddingTop: "18px !important",
            padding: { xs: "8px !important", md: "20px 24px !important" },
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={5}>
              <Box display="flex" mb={1}>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bolder", minWidth: "30%" }}
                >
                  Trans ID
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ minWidth: "70%" }}
                >
                  {jobDetailSummary?.transId || ""}
                </Typography>
              </Box>
              <Box display="flex" mb={1}>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bolder", minWidth: "30%" }}
                >
                  Employee ID
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ minWidth: "70%" }}
                >
                  {selectedEmployee?.EMPID || ""}
                </Typography>
              </Box>
              <Box display="flex">
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bolder", minWidth: "30%" }}
                >
                  Employee Name
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ minWidth: "70%" }}
                >
                  {selectedEmployee?.EMPName || ""}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box display="flex" mb={1}>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bolder", minWidth: "30%" }}
                >
                  Job Title
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ minWidth: "70%" }}
                >
                  {selectedEmployee?.JobTitleName || ""}
                </Typography>
              </Box>
              <Box display="flex">
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ fontWeight: "bolder", minWidth: "30%" }}
                >
                  Department
                </Typography>
                <Typography
                  variant="body1"
                  component="span"
                  sx={{ minWidth: "70%" }}
                >
                  {selectedEmployee?.Department || ""}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={2} display="flex" justifyContent="center">
              <Box position="relative" display="inline-flex">
                <CircularProgress
                  variant="determinate"
                  value={calculatePercentage()}
                  size={55}
                  thickness={5}
                  color="primary"
                />
                <Box
                  top={0}
                  left={0}
                  bottom={0}
                  right={0}
                  position="absolute"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Typography variant="caption" component="div" color="green">
                    {`${calculatePercentage()}%`}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
          <div style={{ height: "49vh", width: "100%", marginTop: 10 }}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={ratingRows}
              columns={ratingColumns}
              getRowId={(row) => row.SrNo}
              components={{
                Toolbar: GridToolbar,
              }}
              hideFooter={ratingRows.length < 100}
              disableSelectionOnClick
              
            />
          </div>
          <Stack direction={"row"} justifyContent="center">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ marginTop: 12, width: "auto" }}
              onClick={handleSave}
              disabled={
                ratingRows.length === 0 || jobDetailSummary.status === "POST"
              }
            >
              Save
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
      </div>
    </>
  );
}
